import { updateFieldsAjax } from "./shared/investment_helper";

// apparition/disparition des blocs en fonction du data-id
$(function () {
  $(".o-js-tabs").each(function () {
    var parent = $(this),
      links = parent.find(".o-js-tabs__link");

    if (!parent.find(".o-js-tabs__link.active").length) {
      var selectedId = links.eq(0).data("id");
      activateTab(parent, selectedId);
    }

    links.on("click", function () {
      activateTab(parent, $(this).data("id"));
    });
  });

  $(".o-tableHidden").each(function () {
    var block = $(this),
      slideToShow = block.find(".o-tableHidden__line"),
      button = block.find(".o-tableHidden__action p");

    block.on("click", function () {
      slideToShow.toggleClass("active");

      if (slideToShow.hasClass("active")) {
        button.addClass("close");
        button.text("masquer");
      } else {
        button.removeClass("close");
        button.text("afficher la suite");
      }
    });
  });

  // modifier la valeur de colspan suivant le nombre de th

  $(".o-tableCompare").each(function () {
    var block = $(this),
      th = block.find("th"),
      scrollBar = $(".o-scrollBarContainer"),
      nbTh = th.length;

    if (nbTh <= 3) {
      scrollBar.css("display", "none");
    }

    $(".o-table__colspan").each(function () {
      var colspan = $(this);
      colspan.attr("colspan", nbTh);
    });
  });

  // decale le texte suivant le scroll horizontal

  $(".o-scrollContainer").each(function () {
    var block = $(this);

    block.on("scroll", function () {
      var mouv = block.scrollLeft();

      $(".o-table__colspan .textToMove").each(function () {
        var paragraph = $(this);
        paragraph.css("margin-left", mouv);
      });

      $(".o-table--mobile .o-js-tabs__block").each(function () {
        var line = $(this),
          tdToMove = line.find("td").first();
        tdToMove.css("zIndex", "4");
        tdToMove.css({
          transform: "translateX(" + mouv + "px)",
        });
      });
    });
  });

  // decale le texte suivant le scroll horizontal sur la page fondTable

  $("#di_fondsTable .o-scrollContainer").each(function () {
    var block = $(this);

    block.on("scroll", function () {
      var mouv = block.scrollLeft();

      if ($(window).width() <= 767) {
        $("table tr").each(function () {
          var line = $(this),
            tdToMove = line.find("td").first();
          tdToMove.css("zIndex", "4");
          tdToMove.css("left", mouv);
        });
      }
    });
  });

  // aligner les textes suivant le plus grand texte

  $(".o-table--mobile").each(function () {
    var block = $(this),
      line = block.find("tr"),
      button = $(".o-js-tabs__link");

    line.each(function () {
      bigText = line.find(".o-greenStat__text");

      var heights = [];
      $(".o-greenStat__text").each(function () {
        heights.push($(this).height());
      });
      var max_height = Math.max.apply(null, heights);

      $(".o-greenStat__text").css({ "min-height": max_height + "px" });
    });

    button.on("click", function () {
      line.each(function () {
        bigText = line.find(".o-greenStat__text");

        var heights = [];
        $(".o-greenStat__text").each(function () {
          heights.push($(this).height());
        });
        var max_height = Math.max.apply(null, heights);

        $(".o-greenStat__text").css({ "min-height": max_height + "px" });
      });
    });
  });

  // afficher la bordure de droite suivant le nombre de th
  // place le menu par rapport à la hauteur du thead

  $(".o-tableContainer").each(function () {
    var block = $(this),
      th = block.find("th"),
      borderToShow = block.find(".o-borderHidden"),
      nav = block.find("nav"),
      thead = block.find("thead");

    if (th.length > 3) {
      borderToShow.addClass("show");
    }

    nav.css("margin-top", thead.outerHeight() - 5);
  });

  // affiche le menu sur la page mobile comparatifFull

  $(".o-content__container--mobile").each(function () {
    var block = $(this),
      menuContainer = block.find(".o-buttonMenu__container"),
      button = menuContainer.find(".o-buttonMenu"),
      divToShow = menuContainer.find(".o-buttonMenu__container__hidden"),
      tableMobile = $(".o-table--mobile");

    button.on("click", function () {
      menuContainer.toggleClass("open");
      button.toggleClass("open");
      divToShow.toggleClass("open");
      divToShow.height(tableMobile.outerHeight() + menuContainer.outerHeight());
    });

    divToShow.on("click", function () {
      if (divToShow.hasClass("open")) {
        divToShow.removeClass("open");
        button.removeClass("open");
        menuContainer.toggleClass("open");
      } else {
        divToShow.addClass("open");
        button.addClass("open");
        menuContainer.removeClass("open");
      }
    });
  });

  $(".o-js-hidden-bar-trigger").each(function () {
    var trigger = $(this);
    var hiddenBar = trigger.find(".o-tdDivHidden");

    trigger.on("click", function () {
      if (hiddenBar.hasClass("is-open")) {
        hiddenBar.removeClass("is-open");
      } else {
        hiddenBar.addClass("is-open");
      }
    });
  });

  $(".o-js-table-hidden-column").each(function () {
    var table = $(this);
    var thColspan = table.find(".o-js-colspan");
    var numberCol = table.find("thead > tr:last > th").length;

    thColspan.attr("colspan", numberCol - 2);
  });

  handleTdHidden();

  handleTotalMoney();

  handleTotalMoneyComma();

  handleTotalMoneyNegative();

  handleTotalMoneyCommaNegative();

  handleTotalPercent();

  handleTotalPercentComma();

  handleIndexComma();

  setInfinityOnChange();

  switchBetweenInputs();
});

export function activateTab(parent, id) {
  var links = parent.find(".o-js-tabs__link"),
    blocks = parent.find(".o-js-tabs__block"),
    questions = $(".o-questions"),
    selectedLink = parent.find('.o-js-tabs__link[data-id="' + id + '"]'),
    selectedBlock = parent.find(id + ", " + id + "Mobile"),
    faq = $(id + "Questions");

  links.not(selectedLink).removeClass("active");
  blocks.not(selectedBlock).removeClass("active");
  questions.not(faq).removeClass("active");

  selectedLink.addClass("active");
  selectedBlock.addClass("active");
  faq.addClass("active");
}

export function setLoader(trigger) {
  var container = trigger.closest(".o-js-loader-container");
  var loader = container.find(".o-js-loader");
  var parent = trigger.closest("tr:not(.o-js-tr-table)");
  var parentHeight = parent.height();
  var parentPosition = parent.position().top;

  loader.addClass("is-visible");
  loader.height(parentHeight);
  loader.css("transform", "translate(0, " + parentPosition + "px)");
}

export function disableLoader(trigger) {
  var container = trigger.closest(".o-js-loader-container");
  var loader = container.find(".o-js-loader");
  loader.removeClass("is-visible");
}

export function handleFieldsOnKeyup() {
  let isTypingShortcut = false;
  var fields = $(".o-js-field");

  fields.each(function () {
    $(this).on("keyup keydown", (e) => {
      const key = e.key;
      const regexNoDecimal =
        /([0-9]|Shift|CapsLock|Esc|Escape|Left|ArrowLeft|Right|ArrowRight|Tab|Backspace|Meta|Control)$/;
      const regexDecimal =
        /([0-9]|Shift|CapsLock|Esc|Escape|Left|ArrowLeft|Right|ArrowRight|Tab|Backspace|Meta|Control|[,])$/;
      const regexDecimalMinus =
        /([0-9]|Shift|CapsLock|Esc|Escape|Left|ArrowLeft|Right|ArrowRight|Tab|Backspace|Meta|Control|[,]|[-])$/;

      // Handle shortcuts
      if (key === "Meta" || key === "Control") {
        if (e.type === "keydown") {
          isTypingShortcut = true;
        } else if (e.type === "keyup") {
          isTypingShortcut = false;
        }
      }

      if (key === "Enter") {
        e.preventDefault();
        $(this).trigger("blur");
      }

      if ($(this).data("motto") == "%3") {
        if (!key.match(regexNoDecimal) && !isTypingShortcut) {
          e.preventDefault();
        } else if (
          key !== "Backspace" &&
          key !== "ArrowLeft" &&
          key !== "ArrowRight"
        ) {
          const valLength = e.target.value.length;
          if (valLength >= 3 && !isTypingShortcut) {
            e.preventDefault();
          }
        }
      } else if ($(this).data("motto") == "%,") {
        if (!key.match(regexDecimal) && !isTypingShortcut) {
          e.preventDefault();
        }
      } else if ($(this).data("motto") == "%,-") {
        if (!key.match(regexDecimalMinus) && !isTypingShortcut) {
          e.preventDefault();
        }
      } else if ($(this).data("motto") == "€") {
        if (!key.match(regexNoDecimal) && !isTypingShortcut) {
          e.preventDefault();
        }
      } else if ($(this).data("motto") == "€,") {
        if (!key.match(regexDecimal) && !isTypingShortcut) {
          e.preventDefault();
        }
      }
    });
  });
}

export function formatMoneyComma(num) {
  return (
    num
      .toFixed(2)
      .replace(".", ",")
      .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1.") + " €"
  );
}

export function formatPercentComma(num) {
  return num.toFixed(2).replace(".", ",") + " %";
}

export function showSpanOnInputBlur(input, span, inputContainer) {
  input.on("blur", function () {
    span.removeClass("is-hidden");
    inputContainer.addClass("is-hidden");
  });
}

export function removeSpan(input, span, inputContainer) {
  inputContainer.removeClass("is-hidden");
  span.addClass("is-hidden");
  setTimeout(function () {
    input.trigger("focus");
  }, 0);
}

export function transformSpanIntoInput() {
  $(".o-js-value").each(function () {
    let span = $(this);
    let inputContainer = span.next();
    let input = inputContainer.find("input");
    let inputValue = input.val();

    if (input.data("motto")) {
      if (input.data("motto") == "€,") {
        let newValue = inputValue.replace(/,/g, ".");
        span.html(formatMoneyComma(parseFloat(newValue)));
      } else if (input.data("motto") == "€") {
        span.html(input.val().replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " €");
      } else if (input.data("motto") == "%," || input.data("motto") == "%,-") {
        let newValue = inputValue.replace(/,/g, ".");
        span.html(formatPercentComma(parseFloat(newValue)));
      } else {
        span.html(inputValue.replace(/\./g, ",") + " %");
      }
    } else if (input.data("date")) {
      span.html(inputValue.split("-").reverse().join("/"));
    } else {
      span.html(inputValue.replace(/\./g, ","));
    }

    inputContainer.addClass("is-hidden");

    if (!input.attr("readonly")) {
      span.on("click", function () {
        removeSpan(input, span, inputContainer);
      });
    }

    showSpanOnInputBlur(input, span, inputContainer);
  });
}

export function hideColumn(table) {
  table.each(function () {
    var table = $(this);
    var showColumnsBtn = table.prev();
    var hideColumnsBtn = table.find(".o-js-hide-column-btn");
    var btnIndex = hideColumnsBtn.data("columnToHide");
    var numberCol = table.find("thead > tr:last > th").length;
    var result = numberCol - btnIndex + 1;
    var lastBeforeResult = numberCol - 2;

    if (hideColumnsBtn.hasClass("is-hidden")) {
      hideTableElements(table, result, lastBeforeResult, showColumnsBtn);
    } else {
      showTableElements(table, result, lastBeforeResult);
    }

    hideColumnsBtn.on("click", function () {
      $(this).addClass("is-hidden");
      hideTableElements(table, result, lastBeforeResult, showColumnsBtn);
      handleTdHidden();
    });

    showColumnsBtn.on("click", function () {
      showTableElements(table, result, lastBeforeResult);
      showColumnsBtn.removeClass("is-visible");
      hideColumnsBtn.removeClass("is-hidden");
      handleTdHidden();
    });
  });
}

export function hideTableElements(table, index, lastIndex, btn) {
  table.find("tr td:nth-child(n+" + index + ")").addClass("is-hidden");
  table.find("tr th:nth-child(n+" + index + ")").addClass("is-hidden");
  table
    .find("tr td:nth-child(" + lastIndex + ")")
    .addClass("is-without-border-right");
  btn.addClass("is-visible");
}

export function showTableElements(table, index, lastIndex) {
  table.find("tr td:nth-child(n+" + index + ")").removeClass("is-hidden");
  table.find("tr th:nth-child(n+" + index + ")").removeClass("is-hidden");
  table
    .find("tr td:nth-child(" + lastIndex + ")")
    .removeClass("is-without-border-right");
}

export function handleTdHidden() {
  var tdsHidden = $(".o-js-tdDivHidden");

  tdsHidden.each(function () {
    var td = $(this);
    var parent = td.parent();
    var line = td.closest("tr");
    var lineWidth = line.width();
    var parentWidth = parent.width();
    var tdWidth = lineWidth - parentWidth;

    parent.on("mouseover", function () {
      td.width(tdWidth);
    });

    parent.on("mouseleave", function () {
      td.width("0");
    });
  });
}

export function handleTotalMoney() {
  $(".o-js-is-money").each(function () {
    var oldValue = $(this).text();
    var digitValue = oldValue.replace(/\D/g, "");
    $(this).val(digitValue === "0" ? "" : digitValue);
    $(this).html(digitValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " €");
  });
}

export function handleTotalMoneyNegative() {
  $(".o-js-is-money-negative").each(function () {
    var oldValue = $(this).text();
    var digitValue = oldValue.replace(/^0-9-/g, "");
    $(this).val(digitValue === "0" ? "" : digitValue);
    $(this).html(digitValue.replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " €");
  });
}

export function handleTotalMoneyCommaNegative() {
  $(".o-js-is-money-comma-negative").each(function () {
    var oldValue = $(this).text();
    var digitValue = oldValue.replace(/^0-9-/g, "");
    $(this).val(digitValue === "0" ? "" : digitValue);
    $(this).html(formatMoneyComma(parseFloat(digitValue)));
  });
}

export function handleTotalMoneyComma() {
  $(".o-js-is-money-comma").each(function () {
    var oldValue = $(this).text();
    let newValue = oldValue.replace(/,/g, ".");
    $(this).html(formatMoneyComma(parseFloat(newValue)));
  });
}

export function handleTotalPercent() {
  $(".o-js-is-percent").each(function () {
    var oldValue = $(this).text();
    var newValue = oldValue.replace(/\./g, ",");

    if ($.trim(newValue) != "") {
      $(this).html(newValue + " %");
    }
  });
}

export function handleTotalPercentComma() {
  $(".o-js-is-percent-comma").each(function () {
    var oldValue = $(this).text();
    let newValue = oldValue.replace(/,/g, ".");
    $(this).html(formatPercentComma(parseFloat(newValue)));
  });
}

export function handleIndexComma() {
  $(".o-js-is-index").each(function () {
    var oldValue = $(this).text();
    var newValue = parseFloat(oldValue);

    $(this).html(newValue.toFixed(2).replace(".", ","));
  });
}

export function setInfinityOnChange() {
  let selects = $(".o-js-estate_type");

  selects.each(function () {
    let inputDuration = $(this)
      .closest(".nested-fields")
      .find(".o-js-duration");
    let spanDuration = inputDuration.closest("td").find(".o-js-value");

    if ($(this).val() == "freehold") {
      spanDuration.html("\u221e");
    }

    $(this).on("change", function () {
      if ($(this).val() == "freehold") {
        spanDuration.html("\u221e");
      }
    });
  });
}

export function switchBetweenInputs() {
  var inputs = $(".o-js-to-tab");
  inputs.each(function () {
    var parentTd = $(this).closest(".o-td-with-input-tab");
    var parentTr = $(this).closest(".nested-fields");
    var nextParentTr = parentTr.nextAll(".nested-fields").eq(0);
    var nextParent = parentTd.nextAll(".o-td-with-input-tab").eq(0);
    var nextParentInput = nextParent.find(".o-js-to-tab");
    var nextInputContainer = nextParent.find(".form-group.is-hidden");
    var nextInputContainerSpan = nextParent.find(".o-js-value");

    $(this).on("keydown", (e) => {
      const key = e.key;

      if (key === "Tab") {
        if (nextParent.length > 0) {
          removeSpan(
            nextParentInput,
            nextInputContainerSpan,
            nextInputContainer,
          );
        } else {
          var nextLineParentTd = nextParentTr
            .find(".o-td-with-input-tab")
            .first();
          var nextLineInput = nextLineParentTd.find(".o-js-to-tab");
          var nextLineInputContainer = nextLineParentTd.find(
            ".form-group.is-hidden",
          );
          var nextLineInputContainerSpan = nextLineParentTd.find(".o-js-value");
          removeSpan(
            nextLineInput,
            nextLineInputContainerSpan,
            nextLineInputContainer,
          );
        }
      }
    });
  });
}

export function handleInputsDate() {
  var datepickers = $(".o-js-date-input");

  datepickers.each(function () {
    let datepicker = $(this);

    datepicker.Zebra_DatePicker({
      days: [
        "Lundi",
        "Mardi",
        "Mercredi",
        "Jeudi",
        "Vendredi",
        "Samedi",
        "Dimanche",
      ],
      months: [
        "Janvier",
        "Février",
        "Mars",
        "Avril",
        "Mai",
        "Juin",
        "Juillet",
        "Aôut",
        "Septembre",
        "Octobre",
        "Novembre",
        "Décembre",
      ],
      format: "d/m/Y",
      show_clear_date: false,
      show_select_today: false,
      show_icon: false,
      onSelect: function () {
        updateFieldsAjax($(this));
      },
    });
  });

  setDateDatepickers();
}

export function setDateDatepickers() {
  let datepickers = $(".o-js-date-input");

  datepickers.each(function () {
    let datepicker = $(this);
    let datepickerValue = datepicker.val();
    let newdateValue = datepickerValue.split("-").reverse().join("/");

    if (datepicker.data("Zebra_DatePicker")) {
      datepicker.data("Zebra_DatePicker").set_date(newdateValue);
    }
  });
}
